export const DEFAULT_DECIMALS = 6 // USDC
